import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { useTableStyles } from "@/pages/heat-report/styles/useTableStyles";
import { Box, Paper } from "@material-ui/core";
import { ColDef, ColGroupDef, themeMaterial } from "ag-grid-community"; // Import types
import { AgGridReact } from "ag-grid-react";
import { useTableData } from "./useTableData";

export const StrandTable = () => {
	const classes = useTableStyles();
	const {
		state: { strandData },
	} = useHeatReportContext();

	const { columns, rowData } = useTableData(strandData);

	return (
		<>
			<Paper elevation={0} className={classes.borderAgGridTable}>
				<Box p={0}>
					<div style={{ height: "25rem" }}>
						<AgGridReact
							suppressRowClickSelection={true}
							pagination={false}
							stopEditingWhenCellsLoseFocus={true}
							tooltipShowDelay={0}
							tooltipHideDelay={2000}
							suppressPropertyNamesCheck={true}
							rowData={rowData}
							columnDefs={columns as (ColDef | ColGroupDef)[]}
							domLayout="normal"
							suppressContextMenu
							getRowId={(params) => params.data.id}
						/>
					</div>
				</Box>
			</Paper>
		</>
	);
};
